<template>
  <div
    class="bbp-time-history-item-panel"
    @mouseenter="isHover = false"
    @mouseleave="isHover = true"
  >
    <div class="bbp-time-history-item-panel__sids">
      <div
        v-if="false"
        class="bbp-time-history-item-panel__icon-plus"
        @click="onShowBody"
      >
        <div v-html="isOpen ? minusIcon() : plusIcon()"/>
      </div>
      <div class="bbp-time-history-item-panel__image">
        <img :src="userImage" alt="">
      </div>
      <div class="bbp-time-history-item-panel__text">
        {{ user.username }}
      </div>
    </div>
    <div class="bbp-time-history-item-panel__sids">
      <div
        v-if="false"
        class="bbp-time-history-item-panel__text"
      >
        {{ date }}
      </div>
      <template v-if="isEdit">
        <div
          class="bbp-time-history-item-panel__total"
          :class="[
          isHover && 'bbp-time-history-item-panel__total_hide'
        ]"
        >
          <BBPTimerModalManualCounter
            :manualTimer="totalTime"
            @update="emitTotalTime"
          />
        </div>
        <div
          class="bbp-time-history-item-panel__icon"
          v-html="unSaveIcon()"
          @click="onUnSave"
        />
        <div
          class="bbp-time-history-item-panel__icon"
          v-html="saveIcon()"
          @click="onSave"
        />
      </template>
      <template v-else>
        <div class="bbp-time-history-item-panel__text">
          {{totalTime}}
        </div>
        <div
          class="bbp-time-history-item-panel__icon"
          v-html="editIcon()"
          @click="isEdit = true"
        />
      </template>
      <BBPDatePicker
        v-if="false"
        :class="[isShowModal && 'bbp-time-history-item-panel__date-picker']"
        ref="dataPicker"
        input="{model: 'date'}"
        :model="calendarModel"
        styleType="mini"
        @input="onChangeDate"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import avatarUserDefault from '@/assets/images/avatar-user-default.png'
import {get, debounce} from 'lodash'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'
import {MINUS_ICON, PLUS_ICON, EDIT_ICON, SAVE_ICON, UN_SAVE_ICON} from '@/constants/icons'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'
import BBPTimeHistoryModal
  from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryModal'
import convertToLocationDate from '@/mixin/convertToLocationDate'
import totalSeconds from '@/mixin/createMilliseconds'
import BBPTimerModalManualCounter
  from '@/components/Main/BBPTable/BBPTimer/BBPTimerModal/BBPTimerModalManual/BBPTimerModalManualCounter'

export default {
  name: 'BBPTimeHistoryItemPanel',
  components: {
    BBPDatePicker,
    BBPTimeHistoryModal,
    BBPTimerModalManualCounter
  },
  mixins: [convertSecondsToTime, convertToLocationDate, totalSeconds],
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    position: {
      type: Object,
      default: () => ({})
    },
    currentItem: {
      type: Object,
      default: () => ({})
    },
    isShowModal: {
      type: Boolean,
      default: false
    },
    isShowBody: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    calendarModel: {
      date: new Date()
    },
    isHover: true,
    isEdit: false,
    newItem: {},
    minusIcon: MINUS_ICON,
    plusIcon: PLUS_ICON,
    editIcon: EDIT_ICON,
    unSaveIcon: UN_SAVE_ICON,
    saveIcon: SAVE_ICON
  }),
  computed: {
    user () {
      const {user = []} = this.item
      const [item] = user
      return item
    },
    userImage () {
      return get(this.user, 'image.path', avatarUserDefault)
    },
    date () {
      const { startDate, endDate } = this.item
      return `${moment(startDate).format('hh:mm A')} - ${moment(endDate).format('hh:mm A')}`
    },
    totalTime () {
      const { totalTime = 0 } = this.item
      const sec = Math.floor(totalTime / 1000)
      return this.convertSecondsToTime(sec, true)
    },
    emitTotalTime () {
      return debounce(this.updateTotalTimer, 0)
    },
    openTabs: {
      get () {
        return this.isShowBody
      },
      set (data) {
        this.$emit('update:isShowBody', data)
      }
    },
    isOpen () {
      const { _id } = this.item
      return this.isShowBody.includes(_id)
    }
  },
  methods: {
    onSave () {
      this.isEdit = false
      const { oldStartDate } = this.newItem
      if (!oldStartDate) return
      this.$emit('update:currentItem', { newItem: this.newItem, isTotalTime: true })
    },
    onUnSave () {
      this.$emit('update:currentItem', { newItem: this.item, isTotalTime: false })
      this.isEdit = false
    },
    defaultValue () {
      const { startDate } = this.item
      this.calendarModel.date = new Date(startDate)
    },
    onShowBody () {
      const { _id } = this.item
      const index = this.openTabs.findIndex((el) => el === _id)
      if (index === -1) {
        this.openTabs.push(_id)
      } else {
        this.openTabs.splice(index, 1)
      }
    },
    onChangeDate (date) {
      this.calendarModel.date = date
    },
    updateTotalTimer (newVal) {
      const sum = this.totalSeconds(newVal)
      const { startDate } = this.item
      const newItem = {
        ...this.item,
        oldStartDate: moment(startDate).format('D-M-YYYY'),
        totalTime: sum
      }
      this.newItem = newItem
    },
    createPositionPopup () {
      const { top, left } = this.$refs.dataPicker.$el.getBoundingClientRect()
      const position = {
        top: `${top}px`,
        left: `${left}px`
      }
      this.$emit('update:position', position)
    },
    createNewDate (date, newDate) {
      const [, timeStart] = date.split('T')
      const day = moment(new Date(newDate)).format('YYYY-MM-DD')
      return this.convertToLocationDate(`${day}T${timeStart}`)
    }
  },
  watch: {
    'calendarModel.date' (newVal) {
      const { startDate, endDate } = this.item
      if (moment(newVal).format('D-M-YYYY') === moment(startDate).format('D-M-YYYY')) return
      this.createPositionPopup()
      setTimeout(() => {
        this.$emit('update:isShowModal', !this.isShowModal)

        const newItem = {
          ...this.item,
          oldStartDate: moment(startDate).format('D-M-YYYY'),
          newStartDate: moment(newVal).format('D-M-YYYY'),
          startDate: this.createNewDate(startDate, newVal),
          endDate: this.createNewDate(endDate, newVal)
        }
        this.$emit('update:currentItem', newItem)
      }, 200)
    }
  },
  beforeMount () {
    this.defaultValue()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

.bbp-time-history-item-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 22px 0 0 0;

  &__sids {
    display: flex;
    align-items: center;
  }

  &__icon-plus {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    border: 1px solid $color-silver;
    padding: 3px;
    border-radius: 2px;
    color: $color-denim;
    cursor: pointer;
    margin: 0 15px 0 0;
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      opacity: 0.8;
    }

    &:last-child {
      margin-left: 5px;
    }
  }

  &__image {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 8px 0 0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__text {
    font-size: 14px;
    line-height: 17px;
    font-weight: 400;
    text-transform: capitalize;
  }

  &__total {
    position: relative;
    margin: 0 10px 0 18px;
    width: 90px;
  }

  &__date-picker {
    pointer-events: none;
  }

}
</style>

<style lang="scss">
@import "../../../../../sass/variables";

.bbp-time-history-item-panel {

  .bbp-date-picker-body_mini {
    grid-template-columns: 1fr !important;
  }

  .bbp-date-picker-body__date {
    display: none;
  }

  .BBP-timer-modal-manual-counter {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .bbp-time-history-item-panel__total_hide
  .BBP-timer-modal-manual-counter
  .time-picker input {
    border: 1px solid $color-white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistoryItem/BBPTimeHistoryItemPanel.vue